import { PersonalReminderService } from 'data-ng-personal-reminders';
import * as _4 from 'lodash';
import { PathModalService } from './../path_modal_service';

export class ReminderDatePickerModalController {
  constructor(private ngPathModalService: PathModalService, private personalReminderService: PersonalReminderService) {}

  saveDateTime(): void {
    if (this.personalReminderService.isModalDateTimeValid()) {
      this.personalReminderService.saveFinalizedDayAndTime();
      this.ngPathModalService.toggleReminderModal(false);
    }
  }

  get isAllDayReminder(): boolean {
    return _4.get(this.personalReminderService, 'personalReminderData.isAllDayReminder', false);
  }

  toggleAllDaySwitch(): void {
    this.personalReminderService.toggleAllDaySwitch(!this.isAllDayReminder);
  }
}

export class ReminderDatePickerModalComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/modals/path_reminder_modal/reminder_date_picker_modal.html';
  public controller: any = ReminderDatePickerModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/modals/path_reminder_modal/reminder_date_picker_modal.ts